export const GreenMarkerIcon = ({
  fill = 'currentColor',
  width = '21',
  height = '21',
  viewBox = '0 0 21 21',
  ...rest
}: React.SVGProps<SVGSVGElement>) => (
  <svg width={width} height={height} viewBox={viewBox} fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <circle cx="10.5" cy="10.5" r="9.5" stroke={fill} strokeWidth="2" />
    <circle cx="10.5" cy="10.5" r="6.5" stroke={fill} />
    <circle cx="10.5" cy="10.5" r="1.5" fill={fill} />
  </svg>
)
